import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { PositionProps, SpaceProps } from 'styled-system';
import Box from '../Box';

const StyledLabelNew = styled(Box)`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  text-transform: uppercase;
  align-self: ${({ alignSelf }) => alignSelf};
  color: ${({ color }) => color || themeGet('colors.white')};
  background: ${(props) =>
    themeGet(props.bg ? String(props.bg) : 'colors.brand.red')(props)};
  border-radius: 2px;
  font-size: ${themeGet('fontSizes.xxs')}px;
  font-weight: bold;
  padding: 4px 11px;
  white-space: nowrap;
`;

const LabelNew = ({
  alignSelf = 'center',
  children = 'new',
  ...props
}: PositionProps &
  SpaceProps & { alignSelf?: string; children?: React.ReactNode }) => (
  <StyledLabelNew alignSelf={alignSelf} {...props}>
    {children}
  </StyledLabelNew>
);

LabelNew.propTypes = {
  alignSelf: PropTypes.string,
  children: PropTypes.any,
};
export default LabelNew;
